import { render, staticRenderFns } from "./NameField.vue?vue&type=template&id=f387afd8&"
import script from "./NameField.vue?vue&type=script&lang=js&"
export * from "./NameField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports